// ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from './usersContext';

export default function ProtectedRoute({ children, requireStripeConnect = false }) {
  // Use userStatus and isLoading from context
  const { userStatus, isLoading, userDoc } = useUser();
  const location = useLocation();

  // Show loading indicator while checking status
  if (isLoading) {
    // You might want a more sophisticated loading component here
    return <div>Loading...</div>; 
  }

  // Only allow access if the user is fully verified
  if (userStatus === 'verified') {
    // Check if this is a tutor who needs Stripe Connect setup
    if (userDoc?.userType === 'tutor' && requireStripeConnect) {
      // Check if tutor has completed Stripe onboarding
      const hasStripeAccount = userDoc.stripeConnectAccountId;
      const isStripeActive = userDoc.stripeConnectStatus === 'active' || 
                            userDoc.stripeConnectStatus === 'pending_verification';
      
      if (!hasStripeAccount || !isStripeActive) {
        // Tutor needs to complete Stripe setup
        return <Navigate to="/stripe-connect-onboarding" replace />;
      }
    }
    
    return children;
  }

  // For any other status (unregistered, pending_verification, pending_profile),
  // redirect to the Auth page. The Auth page will display the correct UI based on the status.
  // Preserve any existing state (like selectedTutor) in addition to the 'from' location
  return <Navigate to="/Auth" state={{ from: location, ...location.state }} replace />;
}
